"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var MUIList = __importStar(require("../../ui/business/list"));

var load_1 = require("../../data/load");

var data_def_1 = require("../data-def");

var footer_1 = __importDefault(require("./footer"));

var List = function List(props) {
  var dataDef = props.dataDef,
      addUrl = props.addUrl,
      showNew = props.showNew,
      selectRow = props.selectRow;
  var columns = data_def_1.dataDefToColumns(dataDef, selectRow);
  return react_1.default.createElement(react_1.default.Fragment, null, props.asyncData !== undefined ? react_1.default.createElement(MUIList.List, {
    asyncData: props.asyncData,
    def: columns,
    config: dataDef.listConfig
  }) : react_1.default.createElement(load_1.WithLoader, {
    Component: MUIList.List,
    dataLoad: props.dataLoad,
    def: columns,
    config: dataDef.listConfig
  }), react_1.default.createElement(footer_1.default, {
    displayType: dataDef.displayType,
    addUrl: addUrl,
    detailPage: dataDef.detailPage,
    onAddClick: showNew
  }));
};

exports.default = List;